import {Image} from "@chakra-ui/react";
import usFlag from "../../images/us_flag.png";
import React from "react";

interface LanguageImageComponentProps {
    src: string,
    alt: string,
    name: string
}


const LanguageImageComponent: React.VFC<LanguageImageComponentProps> = (props) => {
    return <Image
        margin="5px"
        width="24px"
        id={props.name}
        src={props.src}
        alt={props.alt}
        objectFit="contain"
    />
}
export default LanguageImageComponent